import React, { useState } from 'react'
import {
  Notify,
} from "@flexisaf/flexibull2";
import httpClient from "../utils/http-client";

const useCreateSchool = ({ callback }) => {
    const [loading, setIsLoading] = useState(false);
    
  const createSchool = async (data) => {
    setIsLoading(true);
    try {
      const headers = {
        "X-TENANT-ID": data.url_prefix,
      };
      const { data: res } = await httpClient.post(`/signup`, data, { headers });
      Notify("School created. Enter the OTP that was sent to your email.");
      setIsLoading(false);
      callback({...res.ums_login_response, staffId: res.staff.id});
      localStorage.setItem("umsResponse", JSON.stringify({...res.ums_login_response, staffId: res.staff.id}))
    } catch (error) {
      Notify("Something went wrong!", { status: "error" });
      setIsLoading(false);
    }
  };



  return {
    loading,
    createSchool
  }
}

export default useCreateSchool